import validateEmail from './validate-email'
import validateUrl, { isValidURL } from './validate-url'
import validatePhone from './validate-phone'
import handleUpgrade from './handle-upgrade'
import { isMobileMode } from './mobile'

export { validateEmail, validateUrl, isValidURL, validatePhone, handleUpgrade, isMobileMode }
